export const OTHER_VERSION_ELEMENT_HEIGHT = 70;
export const notAvailableFieldText = 'Not Available';
export const LEFT_CENTRAL_BLOCK_WIDTH = 330;
export const BOX_SHADOW_TYPE = 'Field';
export const MACHINE_EVENT_ORDER_BY = 'StartedOn desc';
export const NCFILE_TWO_COLUMN_BREAKPOINT = 1043;
export const NCFILE_MOBILE_BREAKPOINT = 720;
